import {
  CHAT_DRAWER_TITLE_BAR_HEIGHT,
  CHAT_MENU_WIDTH
} from '@components/Chat/constants';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { clsx, colorSet } from '@components/Provider';
import { IconButton, makeStyles } from '@material-ui/core';
import { ChevronLeftOutlined } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import useDocuments from '../../../../hooks/useDocuments';
import useQueryString from '@hooks/useQueryString';

interface Props {
  hasPurchaseOrderHistory: boolean;
}

const PurchaseOrderHeader = ({ hasPurchaseOrderHistory }: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const { query } = useQueryString<{ menu: string }>();
  const formType = query?.menu === 'purchaseorder' ? 'view' : 'create';
  const { onUpdateDocumentsOptions } = useDocuments();

  const onClose = () => {
    history.replace(`${history.location.pathname}`);
  };

  return (
    <>
      {/* 모바일 경우 드랍다운 X */}

      <div className={classes.root}>
        <div className={classes.close} onClick={onClose}>
          <IconButton className="close-button">
            <ChevronLeftOutlined />
          </IconButton>
          <CustomizedTypography variant="body1" color="textPrimary">
            닫기
          </CustomizedTypography>
        </div>

        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          fontWeight="500"
        >
          제조현황
        </CustomizedTypography>

        {formType === 'view' && hasPurchaseOrderHistory && (
          <div className={classes.openList}>
            <CustomizedButton
              id="purchaseorder__dropdown"
              onClick={(e) => {
                e.stopPropagation();
                onUpdateDocumentsOptions({
                  listAnchorId: e.currentTarget.id
                });
              }}
              variant="text"
            >
              발주이력
            </CustomizedButton>
          </div>
        )}
      </div>

      <div className={clsx(classes.root, 'empty')} />
    </>
  );
};

export default PurchaseOrderHeader;

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    width: `calc(100% - ${CHAT_MENU_WIDTH}px)`,
    height: `${CHAT_DRAWER_TITLE_BAR_HEIGHT}px`,
    borderBottom: `1px solid ${colorSet.gray400}`,
    borderRight: `1px solid ${colorSet.gray400}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 16px',
    zIndex: theme.zIndex.drawer + 2,
    backgroundColor: colorSet.gray000,
    [theme.breakpoints.down('md')]: {
      width: 'calc(100%)'
    },

    '&.empty': {
      minHeight: 49,
      position: 'relative',
      zIndex: -1,
      visibility: 'hidden'
    }
  },

  close: {
    position: 'absolute',
    display: 'flex',
    top: 12,
    left: 16,
    '& .close-button': {
      position: 'unset',
      padding: 0,
      width: 24,
      height: 24
    }
  },
  openList: {
    position: 'absolute',
    display: 'flex',
    top: 12,
    right: 16,
    '& .close-button': {
      position: 'unset',
      padding: 0,
      width: 24,
      height: 24
    }
  }
}));
